import React, { ReactNode } from 'react'
import { ClientSecureWrapper } from './client/ClientSecureWrapper'

interface Props {
  children?: ReactNode
  onBack?: () => void
  onSkip?: () => void
}

export const SecureWrapper = ({ children, onBack, onSkip }: Props) => {
  return <ClientSecureWrapper children={children} onBack={onBack} onSkip={onSkip} />
}
